import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import Link from '@uikit/components/Link/Link';
import Stack from '@uikit/components/Stack/Stack';
import mapSmall from '../../assets/images/teasers/map-small.svg';
import wallBoxImage from '../../assets/images/teasers/wallbox.webp';
import { ButtonStyle } from '../ButtonStyle/ButtonStyle';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Headline } from '../Headline/Headline';
import { TeaserCard } from '../TeaserCard/TeaserCard';
import { Text } from '../Text/Text';
import styles from './Teasers.module.scss';

export const Teasers = () => {
  const { pushDataLayerEvent } = useDataLayer();

  return (
    <div className={styles.base}>
      <ContentContainer>
        <Stack
          gap={{ initial: '0.75rem', md: '1.5rem' }}
          flexDirection={{ initial: 'column', md: 'row' }}
        >
          <TeaserCard
            className={styles.firstTeaser}
            variant={'blue'}
            backgroundImage={mapSmall}
          >
            <Headline color={'white'} level={3} align={'left'}>
              <strong>Öffentliche Ladestationen</strong>
            </Headline>

            <Text
              className={styles.cardDescription}
              color={'white'}
              size={16}
              desktopScale={1.25}
              lineHeight={1.375}
              weight={300}
            >
              Finden Sie mit unserer Karte einen von rund 150.000 Ladepunkten
              ganz in Ihrer Nähe.
            </Text>

            <Link
              to="https://karten.enercity.de/oeffentliches-laden"
              onClick={($event) => {
                pushDataLayerEvent({
                  event: 'customClick',
                  clickContext: 'Öffentliche Ladestationen',
                  customClickText: $event.currentTarget.innerText,
                  customPagePath: window.location.pathname,
                });
              }}
            >
              <ButtonStyle color="blue" variant="secondary">
                Zur Ladestationen-Karte
              </ButtonStyle>
            </Link>
          </TeaserCard>

          <TeaserCard variant={'orange'} backgroundImage={wallBoxImage}>
            <Headline color={'white'} level={3} align={'left'}>
              <strong>Wallboxen</strong>
            </Headline>

            <Text
              className={styles.cardDescription}
              color={'white'}
              size={16}
              desktopScale={1.25}
              lineHeight={1.375}
              weight={300}
            >
              Mit unseren Wallboxen laden Sie Ihr E-Auto ganz bequem zu Hause.
            </Text>

            <Link
              to="/privatkunden/produkte/elektromobilitaet/wallbox"
              onClick={($event) => {
                pushDataLayerEvent({
                  event: 'customClick',
                  clickContext: 'Wallboxen',
                  customClickText: $event.currentTarget.innerText,
                  customPagePath: window.location.pathname,
                });
              }}
            >
              <ButtonStyle color="orange" variant="secondary">
                Jetzt konfigurieren
              </ButtonStyle>
            </Link>
          </TeaserCard>
        </Stack>
      </ContentContainer>
    </div>
  );
};
